import { ConfigProvider, theme as antdTheme } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import { routing } from "./routing";
import { ErrorBoundary } from "Components/ErrorBoundary/ErrorBoundary.jsx";

// Setup Locator.js in development
if (import.meta.env.DEV) {
  import("@locator/runtime").then((locator) => locator.default());
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

// App wrapper component with dark mode enforced
const AppWrapper = () => {
  // Apply dark mode class to document root on mount
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "hsl(309 32% 61%)",
          },
          algorithm: antdTheme.darkAlgorithm,
        }}
      >
        <ErrorBoundary>
          <RouterProvider
            router={routing}
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          />
        </ErrorBoundary>
      </ConfigProvider>
    </QueryClientProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(<AppWrapper />);
